import type { FilterLimits } from './types';

export const TIME_INTERVALS = [0, 1440];
export const DEFAULT_FILTER_LIMITS: FilterLimits = {
  prices: [],
  transferDuration: [],
  flightDurationRange: [],
};
